// extracted by mini-css-extract-plugin
module.exports = {"Text":"_2dgux9KtYaJREUxfZj-kTG","Spinner":"_1A39G49_ueOkeOqbU1TVos","SpinnerSmall":"_3nAUpyNrlQjP5jixoQ6LS6","spinner":"_1Lxz9S79tzNj8fYoFE7ajb"};